define('controllers/consoleApi/oauthClient.apiList.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('OauthClientApiList', ['$scope', '$state', '$stateParams', '$rootScope', 'projectManageService', 'auiDialog',
        function ($scope, $state, $stateParams, $rootScope, projectManageService, auiDialog) {
            var Model = $scope.Model = {
                projectID: $stateParams.projectID,
                clientID: $stateParams.clientID
            };
            Model.openStateFilter = mainCons.oauthConstant.openStateFilter;
            $scope.modOauthClientApi = modOauthClientApi;
            $scope.delOauthClientApi = delOauthClientApi;
            $scope.applyNewOauthClientApi = applyNewOauthClientApi;
            $scope.viewOauthClientApi = viewOauthClientApi;
            $scope.cancel = cancel;
            init();

            function init() {
                if (!Model.projectID || !Model.clientID) {
                    cancel();
                } else {
                    projectManageService.getProjectInfo({projectID: Model.projectID}).then(function (data) {
                        if (data && data.projectInfo) {
                            Model.myProject = data.projectInfo;
                            projectManageService.getApiIDToNameFilter().then(function (apiIDToNameFilter) {
                                Model.apiIDToNameFilter =apiIDToNameFilter;
                                Model.apiIDToIsAuditFilter = apiIDToNameFilter.apiIDToIsAuditFilter;
                                initApiList();
                            });

                        } else {
                            cancel();
                        }
                    });
                }
            }

            function initApiList() {
                projectManageService.getProjectCredentialList(Model.myProject.projectID).then(function (oauthdata) {
                    if (oauthdata && oauthdata.limitOauthClientInfoList.length > 0) {
                        oauthdata.limitOauthClientInfoList.forEach(function (limitOauthClientInfo) {
                            if (limitOauthClientInfo.clientID == Model.clientID) {
                                Model.clientIDName = limitOauthClientInfo.oauthClientAttr.clientName;
                                Model.clientID = limitOauthClientInfo.clientID;
                                projectManageService.getAllApiList().then(function (kitsApiList) {
                                    Model.kitsApiList = kitsApiList;
                                    projectManageService.getOauthAPI(Model.projectID, Model.clientID).then(function (resp) {
                                        if (resp && resp.oauthApiList && resp.oauthApiList.length > 0) {
                                            Model.oauthApiList = resp.oauthApiList;
                                            Model.oauthApiList.forEach(function (oauthApi) {
                                                Model.kitsApiList.forEach(function (kitsApi) {
                                                    if (oauthApi.apiID == kitsApi.apiID) {
                                                        oauthApi.apiName = kitsApi.langInfo.apiName;
                                                        oauthApi.isAudit = kitsApi.isAudit;
                                                    }
                                                })
                                            });
                                        } else {
                                            Model.oauthApiList = [];
                                        }
                                    })
                                });
                            }
                        });
                    } else {
                        cancel();
                    }

                });
            }

            function modOauthClientApi(row) {
                $state.go('oauthClientApiDetail', {
                    projectID: Model.myProject.projectID,
                    clientID: Model.clientID,
                    apiID: row.apiID
                }, {reload: true});
            }


            function delOauthClientApi(row) {
                auiDialog.confirm("确定删除此客户端下的API吗？","删除此客户端下的API，会导致此客户端下的该API的权限和资源都被删除，无法继续正常使用。", function () {
                    projectManageService.delOauthAPI(Model.clientID, row.apiID).then(function (resp) {
                        if (resp && resp.resultCode == 0) {
                            auiDialog.success('删除成功', function () {
                                var oauthApiListCopy = [];
                                Model.oauthApiList.forEach(function (oauthApi) {
                                    if (oauthApi.apiID != row.apiID) {
                                        oauthApiListCopy.push(oauthApi);
                                    }
                                });
                                Model.oauthApiList = angular.copy(oauthApiListCopy);
                            });
                        }
                    });
                });
            }

            function viewOauthClientApi(row){
                $state.go('oauthClientApiView', {
                    projectID: Model.myProject.projectID,
                    clientID: Model.clientID,
                    apiID: row.apiID
                }, {reload: true});
            }

            function applyNewOauthClientApi() {
                $state.go('oauthClientApiDetail', {
                    projectID: Model.myProject.projectID,
                    clientID: Model.clientID,
                    apiID: "0"
                }, {reload: true});
            }

            function cancel() {
                $state.go('credentials', {projectKey: ((Model.myProject && Model.myProject.projectKey) ? Model.myProject.projectKey : (projectManageService.getProjectKey() ? projectManageService.getProjectKey() : "0" ))}, {reload: true});
            }

        }
    ]);
});

